<div class="structure">
  <div class="structure__header">
    <div class="structure__title-section">
      <div class="structure__title">
        {{ 'app.components.courseCreator.settings.structure.title' | translate }}
      </div>
    </div>
  </div>

  <div class="structure__content">
    <div class="structure__section">
      <div class="structure__section-label">
        {{ 'app.components.courseCreator.settings.structure.lessonsQuantity' | translate }}
      </div>
      <div class="structure__options">
        @for (option of quantityOptions; track option.value) {
          <button
            type="button"
            class="structure__option"
            [class.structure__option--active]="selectedQuantity() === option.value"
            (click)="selectQuantity(option.value)"
          >
            <span class="structure__option-text">{{ option.translationKey | translate }}</span>
          </button>
        }
      </div>
    </div>

    <div class="structure__section">
      <div class="structure__section-label">
        {{ 'app.components.courseCreator.settings.structure.lessonsDuration' | translate }}
      </div>
      <div class="structure__options">
        @for (option of durationOptions; track option.value) {
          <button
            type="button"
            class="structure__option"
            [class.structure__option--active]="selectedDuration() === option.value"
            (click)="selectDuration(option.value)"
          >
            <span class="structure__option-text">{{ option.translationKey | translate }}</span>
          </button>
        }
      </div>
    </div>
  </div>
</div>
